import { IOptionItem } from '@wyz/types';
import { Button, Flex, Icon, Text } from '@wyz/ui';
import { SelectField } from '~/common/components';
import { Trans } from '~/common/context';

type Props = {
  brand: string;
  colSpan: number;
  bonusTypeOptions: IOptionItem[];
  isSaving: boolean;
  onCancel: () => void;
};

/** Takes over the season columns of the brand row while that brand is being edited. */
export function ExtraBonusEditBar({
  brand,
  colSpan,
  bonusTypeOptions,
  isSaving,
  onCancel,
}: Props) {
  return (
    <td colSpan={colSpan} className='extra-bonus-table__edit-bar'>
      <Flex alignItems='center' className='space-x-2'>
        <Text component='span' color='primary' weight='semi-bold'>
          <Trans i18nKey='app.distribution.pricing_policy.detail.edit.configuration' />
          <span className='extra-bonus-table__required' />
        </Text>
        <SelectField
          name='bonusType'
          size='sm'
          isSearchable={false}
          options={bonusTypeOptions}
          formGroupClassName='extra-bonus-table__type-select'
          required
        />
        <Button
          id={`cancel-${brand}`}
          type='button'
          variant='secondary'
          size='sm'
          onClick={onCancel}
          disabled={isSaving}
        >
          <Icon icon='close' size='xs' />{' '}
          <Trans i18nKey='app.common.button.cancel' />
        </Button>
        <Button
          id={`save-${brand}`}
          type='submit'
          variant='success'
          size='sm'
          disabled={isSaving}
        >
          <Icon icon='check-mark-line' size='xs' />{' '}
          <Trans i18nKey='app.common.button.save' />
        </Button>
      </Flex>
    </td>
  );
}
